import { render, staticRenderFns } from "./UpdateFile.vue?vue&type=template&id=48a28d8e"
import script from "./UpdateFile.vue?vue&type=script&lang=js"
export * from "./UpdateFile.vue?vue&type=script&lang=js"
import style0 from "./UpdateFile.vue?vue&type=style&index=0&id=48a28d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports